import { createFileRoute } from '@tanstack/react-router';
import { AiOpsRunsPage } from '@/pages/super-admin/ai-ops/AiOpsRunsPage';
import { aiOpsRunsSearchSchema } from '@/pages/super-admin/ai-ops/ai-ops.constants';

export const Route = createFileRoute('/_authenticated/super-admin/ai-ops/runs')({
	component: AiOpsRunsPage,
	validateSearch: aiOpsRunsSearchSchema,
});
